<template>
    <div class="bg-[#0C152466] rounded-xl flex flex-col overflow-hidden">
        <!-- Icon / Image -->
        <div class="mb-7">
            <div class="flex items-center justify-center">
                <NuxtImg :src="image" :alt="title" width="380" height="225" class="w-full max-h-[230px] object-cover" loading="lazy" />
            </div>
        </div>


        <div class="min-h-36">
            <h3 class="text-[var(--text-primary)] text-2xl font-semibold mb-3 ">
                {{ title }}
            </h3>
            <p class="text-[var(--text-gray)] text-base mb-6 line-clamp-3">
                {{ description }}
            </p>
        </div>


        <div>
            <Button 
  unstyled 
  label="Learn More" 
  iconPos="left"
  class="group !rounded-xl !px-5 
         !bg-[#132036] hover:!bg-[#1f3258]
         transition-all duration-1000 ease-in-out
         !py-3 font-semibold text-[var(--text-secondary)] 
         flex items-center justify-center gap-3 
         overflow-hidden text-sm sm:text-base"
>

    <span 
      class="flex items-center justify-center w-6 h-6 
             rounded-full bg-gray-700 
             transform transition-all duration-1000 ease-in-out 
             group-hover:translate-x-28"
    >
      <i class="pi pi-angle-right text-white text-lg"></i>
    </span>
  

  <span class="transition-all duration-1000 ease-in-out group-hover:-translate-x-1/2">
    Learn More
  </span>
</Button>

        </div>
    </div>
</template>

<script setup lang="ts">
defineProps<{
    image: string
    title: string
    description: string
}>()
</script>
